import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { setMetaTags, setStructuredData } from '@/utils/seo'

const BASE_URL = 'https://zerofour04.dev'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Fullstack-Entwickler aus München',
      description: 'Ben Ho – Fullstack-Entwickler aus München. Portfolio mit Projekten in Vue.js, Nuxt, React und modernen Webtechnologien. Webentwicklung mit Leidenschaft.',
      keywords: 'Ben Ho, Fullstack-Entwickler, Webentwickler München, Vue.js, Nuxt, React, Portfolio, Frontend, Backend'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: {
      title: 'Über mich | Entwickler & Informatikstudent',
      description: 'Ben Ho – Fullstack-Entwickler aus München. Informatikstudent und Werkstudent mit Erfahrung in Vue.js, Nuxt, React und TypeScript. Projekte & Skills.',
      keywords: 'Ben Ho, Fullstack-Entwickler, Webentwickler München, Informatikstudent, Vue.js, Nuxt, React, TypeScript'
    }
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: () => import('../views/PortfolioView.vue'),
    meta: {
      title: 'Portfolio | Projekte & Webanwendungen',
      description: 'Projekte von Ben Ho – Fullstack-Entwickler aus München. Webanwendungen mit Vue.js, Nuxt, React, Stripe und mehr. Entdecke meine Arbeiten.',
      keywords: 'Portfolio, Ben Ho, Projekte, Vue.js, Nuxt, React, Stripe, Webentwicklung München'
    }
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import('../views/BlogView.vue'),
    meta: {
      title: 'Blog | Webentwicklung & Technologie',
      description: 'Blog von Ben Ho – Fullstack-Entwickler aus München. Artikel über Webentwicklung, Technologie, Softwareentwicklung und Best Practices.',
      keywords: 'Blog, Ben Ho, Softwareentwicklung, Webentwicklung München, Vue.js, Technologie'
    }
  },
  {
    path: '/read/:slug/:id',
    name: 'articleDetail',
    component: () => import('../views/ArticleView.vue'),
    meta: {
      title: 'Blog',
      isDynamic: true // Artikel setzen ihre eigenen Meta-Tags
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue'),
    meta: {
      title: 'Kontakt | Projektanfragen & Zusammenarbeit',
      description: 'Kontaktiere Ben Ho – Fullstack-Entwickler aus München. Für Projektanfragen, Zusammenarbeit oder Fragen zu Webentwicklung und Softwareprojekten.',
      keywords: 'Kontakt, Ben Ho, Projektanfrage, Zusammenarbeit, Webentwicklung München'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue'),
    meta: {
      title: 'Datenschutzerklärung',
      description: 'Datenschutzerklärung von zerofour04.dev – Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO.',
      robots: 'noindex, follow'
    }
  },
  {
    path: '/imprint',
    name: 'imprint',
    component: () => import('../views/ImprintView.vue'),
    meta: {
      title: 'Impressum',
      description: 'Impressum und rechtliche Hinweise von zerofour04.dev.',
      robots: 'noindex, follow'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, _from, next) => {
  // Für dynamische Routen (Artikel) werden Meta-Tags in der Komponente gesetzt
  if (to.meta.isDynamic) {
    next();
    return;
  }

  const fullUrl = `${BASE_URL}${to.path === '/' ? '' : to.path}`;

  // Meta-Tags setzen
  setMetaTags({
    title: `${to.meta.title} - BenHo();`,
    description: to.meta.description,
    url: fullUrl,
    image: `${BASE_URL}/preview-image.jpg`,
    type: 'website',
    keywords: to.meta.keywords,
    robots: to.meta.robots || 'index, follow'
  });

  // Strukturierte Daten für die Website
  if (to.name === 'home') {
    setStructuredData({
      '@context': 'https://schema.org',
      '@type': 'Person',
      'name': 'Ben Ho',
      'url': BASE_URL,
      'jobTitle': 'Fullstack-Entwickler',
      'address': {
        '@type': 'PostalAddress',
        'addressLocality': 'München',
        'addressCountry': 'DE'
      },
      'sameAs': [
        'https://github.com/Zerofour04'
      ]
    });
  } else if (to.name === 'blog') {
    setStructuredData({
      '@context': 'https://schema.org',
      '@type': 'Blog',
      'name': 'Ben Ho Blog',
      'description': to.meta.description,
      'url': fullUrl,
      'author': {
        '@type': 'Person',
        'name': 'Ben Ho'
      }
    });
  }

  next();
});

export default router
